
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ski-resort",
      function () {
        return require("private-next-pages/ski-resort.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ski-resort"])
      });
    }
  